import { jobLists } from "character";
import { EorzeaDataType, GameData, Job, Market, RelicData } from "enums";
import { Info } from "types/game";

export const ewItems = {
	[GameData.Item.MANDERIUM_METEORITE]: {
		name: GameData.Item.MANDERIUM_METEORITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.JUBRUNNAH, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, RelicData.Part.WEAPON_MANDERVILLE, RelicData.Step.MANDERVILLE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_MANDERVILLE],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.COMPLEMENTARY_CHONDRITE]: {
		name: GameData.Item.COMPLEMENTARY_CHONDRITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.JUBRUNNAH, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, RelicData.Part.WEAPON_AMAZING_MANDERVILLE, RelicData.Step.AMAZING_MANDERVILLE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_MANDERVILLE],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_CHAIR]: {
		name: GameData.Item.CONNOISSEURS_CHAIR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_CHAIR,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_IRONWOOD_LUMBER, qty: 1 },
						{ item: GameData.Item.IRONWOOD_LOG, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_WALL_LANTERN]: {
		name: GameData.Item.CONNOISSEURS_WALL_LANTERN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_WALL_LANTERN,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.PHRYGIAN_GOLD_ORE, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_ORNATE_DOOR]: {
		name: GameData.Item.CONNOISSEURS_ORNATE_DOOR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_ORNATE_DOOR,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_TITANIUM_PLATE, qty: 1 },
						{ item: GameData.Item.IRONWOOD_LOG, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_VANITY_MIRROR]: {
		name: GameData.Item.CONNOISSEURS_VANITY_MIRROR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_VANITY_MIRROR,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_CRYSTAL_GLASS, qty: 1 },
						{ item: GameData.Item.BISMUTH_ORE, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_RUG]: {
		name: GameData.Item.CONNOISSEURS_RUG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_RUG,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_SMILODON_LEATHER, qty: 1 },
						{ item: GameData.Item.ALMASTY_FUR, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_SWAG_VALANCE]: {
		name: GameData.Item.CONNOISSEURS_SWAG_VALANCE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_SWAG_VALANCE,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_SCARLET_MOKO_CLOTH, qty: 1 },
						{ item: GameData.Item.ALMASTY_FUR, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_COSMETICS_BOX]: {
		name: GameData.Item.CONNOISSEURS_COSMETICS_BOX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_COSMETICS_BOX,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_HOPTRAP_LEAF, qty: 1 },
						{ item: GameData.Item.PETALOUDA_SCALES, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_PIXIEBERRY_TEA]: {
		name: GameData.Item.CONNOISSEURS_PIXIEBERRY_TEA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_PIXIEBERRY_TEA,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_PIXIEBERRY, qty: 1 },
						{ item: GameData.Item.SIDERITIS_LEAVES, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_PRISMSTONE]: {
		name: GameData.Item.CONNOISSEURS_PRISMSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.TIMH_GYEUS, x: 11, y: 36 }, method: GameData.GatherMethod.MINING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 60, maxQtyPerJob: 180,
			},
		],
	},
	[GameData.Item.SPLENDOROUS_WATER_SHARD]: {
		name: GameData.Item.SPLENDOROUS_WATER_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.TIMH_GYEUS, x: 11, y: 36 }, method: GameData.GatherMethod.MINING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 180,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_WATTLE_PETRIBARK]: {
		name: GameData.Item.CONNOISSEURS_WATTLE_PETRIBARK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.DUERGAR_MOUNTAINS, x: 25, y: 12 }, method: GameData.GatherMethod.LOGGING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 60, maxQtyPerJob: 180,
			},
		],
	},
	[GameData.Item.SPLENDOROUS_EARTH_SHARD]: {
		name: GameData.Item.SPLENDOROUS_EARTH_SHARD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.DUERGAR_MOUNTAINS, x: 25, y: 12 }, method: GameData.GatherMethod.LOGGING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 180,
			},
		],
	},
	[GameData.Item.PLATINUM_SEAHORSE]: {
		name: GameData.Item.PLATINUM_SEAHORSE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.PLATINUM_SEAHORSE, hole: GameData.Fishing.SOURCE, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CLAVEKEEPER]: {
		name: GameData.Item.CLAVEKEEPER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.CLAVEKEEPER, hole: GameData.Fishing.SEAGAZER_SHOALS, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS, RelicData.Step.SPLENDOROUS_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_MARIMBA]: {
		name: GameData.Item.CONNOISSEURS_MARIMBA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_MARIMBA,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_IRONWOOD_LUMBER, qty: 1 },
						{ item: GameData.Item.INTEGRAL_LUMBER, qty: 1 },
						{ item: GameData.Item.CHONDRITE_INGOT, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_COFFEE_BREWER]: {
		name: GameData.Item.CONNOISSEURS_COFFEE_BREWER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_COFFEE_BREWER,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.STAR_QUARTZ, qty: 1 },
						{ item: GameData.Item.CHONDRITE_INGOT, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_BENCH]: {
		name: GameData.Item.CONNOISSEURS_BENCH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_BENCH,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_TITANIUM_PLATE, qty: 1 },
						{ item: GameData.Item.INTEGRAL_LUMBER, qty: 1 },
						{ item: GameData.Item.CHONDRITE_INGOT, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_ASTROSCOPE]: {
		name: GameData.Item.CONNOISSEURS_ASTROSCOPE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_ASTROSCOPE,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_CRYSTAL_GLASS, qty: 1 },
						{ item: GameData.Item.STAR_QUARTZ, qty: 1 },
						{ item: GameData.Item.CHONDRITE_INGOT, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_LEATHER_SOFA]: {
		name: GameData.Item.CONNOISSEURS_LEATHER_SOFA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_LEATHER_SOFA,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_SMILODON_LEATHER, qty: 1 },
						{ item: GameData.Item.INTEGRAL_LUMBER, qty: 1 },
						{ item: GameData.Item.AR_CAEAN_VELVET, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_RED_CARPET]: {
		name: GameData.Item.CONNOISSEURS_RED_CARPET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_RED_CARPET,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_SCARLET_MOKO_CLOTH, qty: 1 },
						{ item: GameData.Item.AR_CAEAN_VELVET, qty: 1 },
						{ item: GameData.Item.OPHIOTAUROS_LEATHER, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_ELIXIR_BOTTLE]: {
		name: GameData.Item.CONNOISSEURS_ELIXIR_BOTTLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_ELIXIR_BOTTLE,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_HOPTRAP_LEAF, qty: 1 },
						{ item: GameData.Item.GRADE_5_VITALITY_ALKAHEST, qty: 1 },
						{ item: GameData.Item.GRADE_5_MIND_ALKAHEST, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_PIXIEBERRY_TART]: {
		name: GameData.Item.CONNOISSEURS_PIXIEBERRY_TART,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_PIXIEBERRY_TART,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_PIXIEBERRY, qty: 1 },
						{ item: GameData.Item.DARK_RYE_FLOUR, qty: 1 },
						{ item: GameData.Item.PALM_SUGAR, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_RED_MALACHITE]: {
		name: GameData.Item.CONNOISSEURS_RED_MALACHITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.FIELDS_OF_AMBER, x: 28, y: 14 }, method: GameData.GatherMethod.MINING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 70, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.ADAPTIVE_FIRE_CRYSTAL]: {
		name: GameData.Item.ADAPTIVE_FIRE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.FIELDS_OF_AMBER, x: 28, y: 14 }, method: GameData.GatherMethod.MINING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 210,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_LEVIN_MINT]: {
		name: GameData.Item.CONNOISSEURS_LEVIN_MINT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.WEATHERING, x: 34, y: 10 }, method: GameData.GatherMethod.LOGGING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 70, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.ADAPTIVE_LIGHTNING_CRYSTAL]: {
		name: GameData.Item.ADAPTIVE_LIGHTNING_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.WEATHERING, x: 34, y: 10 }, method: GameData.GatherMethod.LOGGING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 210,
			},
		],
	},
	[GameData.Item.MIRROR_IMAGE]: {
		name: GameData.Item.MIRROR_IMAGE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.MIRROR_IMAGE, hole: GameData.Fishing.HANDMIRROR_LAKE, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 40, maxQtyPerJob: 80,
			},
		],
	},
	[GameData.Item.SPANGLED_PIRARUCU]: {
		name: GameData.Item.SPANGLED_PIRARUCU,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.SPANGLED_PIRARUCU, hole: GameData.Fishing.LAKE_TUSI_MEKTA, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CRYSTALLINE, RelicData.Step.ADAPTIVE_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 40, maxQtyPerJob: 80,
			},
		],
	},
	[GameData.Item.SELECT_IRONWOOD_LUMBER]: {
		name: GameData.Item.SELECT_IRONWOOD_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_MANGANESE_INGOT]: {
		name: GameData.Item.SELECT_MANGANESE_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_TITANIUM_PLATE]: {
		name: GameData.Item.SELECT_TITANIUM_PLATE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_CRYSTAL_GLASS]: {
		name: GameData.Item.SELECT_CRYSTAL_GLASS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_SMILODON_LEATHER]: {
		name: GameData.Item.SELECT_SMILODON_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_SCARLET_MOKO_CLOTH]: {
		name: GameData.Item.SELECT_SCARLET_MOKO_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_HOPTRAP_LEAF]: {
		name: GameData.Item.SELECT_HOPTRAP_LEAF,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_PIXIEBERRY]: {
		name: GameData.Item.SELECT_PIXIEBERRY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.QUINNANA, cost: [{ price: 50, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.IRONWOOD_LOG]: {
		name: GameData.Item.IRONWOOD_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.KALLIMELIOS_ZEPHYROS, x: 9, y: 23 }, method: GameData.GatherMethod.LOGGING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.PHRYGIAN_GOLD_ORE]: {
		name: GameData.Item.PHRYGIAN_GOLD_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.EBLAN_RIME, x: 21, y: 29 }, method: GameData.GatherMethod.QUARRYING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.BISMUTH_ORE]: {
		name: GameData.Item.BISMUTH_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.SOUTHERN_MARE_LAMENTORUM, x: 29, y: 36 }, method: GameData.GatherMethod.MINING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.ALMASTY_FUR]: {
		name: GameData.Item.ALMASTY_FUR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.ALMASTY],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.ZAWAWA, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.PETALOUDA_SCALES]: {
		name: GameData.Item.PETALOUDA_SCALES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.IANTHINE_PETALOUDA, GameData.Enemy.KOKKINE_PETALOUDA, GameData.Enemy.KYANE_PETALOUDA],
			shops: [
				{ shop: GameData.Shop.AISARA, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SIDERITIS_LEAVES]: {
		name: GameData.Item.SIDERITIS_LEAVES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.PHILOMYTHES_NOTOS, x: 21, y: 24 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.INTEGRAL_LUMBER]: {
		name: GameData.Item.INTEGRAL_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.INTEGRAL_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 88,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.INTEGRAL_LOG, qty: 5 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.CHONDRITE_INGOT]: {
		name: GameData.Item.CHONDRITE_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CHONDRITE_INGOT,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 88,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CHONDRITE, qty: 5 },
						{ item: GameData.Item.DIMYTHRITE_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 8 },
					],
				},
				{
					itemMade: GameData.Item.CHONDRITE_INGOT,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 88,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CHONDRITE, qty: 5 },
						{ item: GameData.Item.DIMYTHRITE_ORE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.STAR_QUARTZ]: {
		name: GameData.Item.STAR_QUARTZ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.STAR_QUARTZ,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 88,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ANNITE_WHETSTONE, qty: 1 },
						{ item: GameData.Item.RAW_STAR_QUARTZ, qty: 3 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.AR_CAEAN_VELVET]: {
		name: GameData.Item.AR_CAEAN_VELVET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.AR_CAEAN_VELVET,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 88,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.AR_CAEAN_COTTON_BOLL, qty: 5 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.OPHIOTAUROS_LEATHER]: {
		name: GameData.Item.OPHIOTAUROS_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.OPHIOTAUROS_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 88,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.OPHIOTAUROS_HIDE, qty: 4 },
						{ item: GameData.Item.EBLAN_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.GRADE_5_VITALITY_ALKAHEST]: {
		name: GameData.Item.GRADE_5_VITALITY_ALKAHEST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.GRADE_5_VITALITY_ALKAHEST,
					qtyMade: 3,
					crafter: Job.ALC,
					level: 83,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.UNDERGROUND_SPRING_WATER, qty: 2 },
						{ item: GameData.Item.LUNATENDER_BLOSSOM, qty: 1 },
						{ item: GameData.Item.LIME_BASIL, qty: 2 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.GRADE_5_MIND_ALKAHEST]: {
		name: GameData.Item.GRADE_5_MIND_ALKAHEST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.GRADE_5_MIND_ALKAHEST,
					qtyMade: 3,
					crafter: Job.ALC,
					level: 83,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.UNDERGROUND_SPRING_WATER, qty: 2 },
						{ item: GameData.Item.LUNATENDER_BLOSSOM, qty: 1 },
						{ item: GameData.Item.TIGER_LILY, qty: 2 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.DARK_RYE_FLOUR]: {
		name: GameData.Item.DARK_RYE_FLOUR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DARK_RYE_FLOUR,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 81,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARK_RYE, qty: 6 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.PALM_SUGAR]: {
		name: GameData.Item.PALM_SUGAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PALM_SUGAR,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 82,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.PALM_SYRUP, qty: 6 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.INTEGRAL_LOG]: {
		name: GameData.Item.INTEGRAL_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.OSTRAKON_DEKA_OKTO, x: 8, y: 22 }, method: GameData.GatherMethod.LOGGING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.CHONDRITE]: {
		name: GameData.Item.CHONDRITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.OSTRAKON_TRIA, x: 19, y: 13 }, method: GameData.GatherMethod.MINING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.ANNITE_WHETSTONE]: {
		name: GameData.Item.ANNITE_WHETSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ANNITE_WHETSTONE,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 86,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ANNITE, qty: 4 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.RAW_STAR_QUARTZ]: {
		name: GameData.Item.RAW_STAR_QUARTZ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.OSTRAKON_DEKA_OKTO, x: 21, y: 33 }, method: GameData.GatherMethod.QUARRYING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.AR_CAEAN_COTTON_BOLL]: {
		name: GameData.Item.AR_CAEAN_COTTON_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.OSTRAKON_DEKA_OKTO, x: 14, y: 28 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.OPHIOTAUROS_HIDE]: {
		name: GameData.Item.OPHIOTAUROS_HIDE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.OPHIOTAUROS],
			shops: [
				{ shop: GameData.Shop.AISARA, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.EBLAN_ALUMEN]: {
		name: GameData.Item.EBLAN_ALUMEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.EBLAN_RIME, x: 21, y: 29 }, method: GameData.GatherMethod.QUARRYING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.UNDERGROUND_SPRING_WATER]: {
		name: GameData.Item.UNDERGROUND_SPRING_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.CHURCH_OF_FIRST_LIGHT, x: 35, y: 15 }, method: GameData.GatherMethod.MINING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.LIME_BASIL]: {
		name: GameData.Item.LIME_BASIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.SULLEN, x: 25, y: 30 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.TIGER_LILY]: {
		name: GameData.Item.TIGER_LILY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.SULLEN, x: 25, y: 30 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.LUNATENDER_BLOSSOM]: {
		name: GameData.Item.LUNATENDER_BLOSSOM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.LUNATENDER],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.TRADINGWAY, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.DARK_RYE]: {
		name: GameData.Item.DARK_RYE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.MEDIAL_CIRCUIT, x: 28, y: 17 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.PALM_SYRUP]: {
		name: GameData.Item.PALM_SYRUP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.PERFUMED_RISE, x: 17, y: 22 }, method: GameData.GatherMethod.LOGGING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.ANNITE]: {
		name: GameData.Item.ANNITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.KALLIMELIOS_ZEPHYROS, x: 14, y: 18 }, method: GameData.GatherMethod.QUARRYING }],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.AMPLIFYING_ACHONDRITE]: {
		name: GameData.Item.AMPLIFYING_ACHONDRITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.JUBRUNNAH, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, RelicData.Part.WEAPON_MAJESTIC_MANDERVILLE, RelicData.Step.MAJESTIC_MANDERVILLE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_MANDERVILLE],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_PICTURE_FRAME]: {
		name: GameData.Item.CONNOISSEURS_PICTURE_FRAME,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_PICTURE_FRAME,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_DARK_CHESTNUT_LUMBER, qty: 1 },
						{ item: GameData.Item.RED_PINE_LUMBER, qty: 1 },
						{ item: GameData.Item.LINEN_CANVAS, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_SAMURAI_BLADE]: {
		name: GameData.Item.CONNOISSEURS_SAMURAI_BLADE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_SAMURAI_BLADE,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BISMUTH_INGOT, qty: 1 },
						{ item: GameData.Item.PEWTER_INGOT, qty: 1 },
						{ item: GameData.Item.OROSHIGANE_INGOT, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_AQUARIUM]: {
		name: GameData.Item.CONNOISSEURS_AQUARIUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_AQUARIUM,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_COBALT_PLATE, qty: 1 },
						{ item: GameData.Item.MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.CRYSTAL_GLASS, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_GLAIVES]: {
		name: GameData.Item.CONNOISSEURS_GLAIVES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_GLAIVES,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BLUESPIRIT_TILE, qty: 1 },
						{ item: GameData.Item.PEWTER_INGOT, qty: 1 },
						{ item: GameData.Item.MANASILVER_NUGGET, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_VARSITY_SHOES]: {
		name: GameData.Item.CONNOISSEURS_VARSITY_SHOES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_VARSITY_SHOES,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_GREEN_GLIDER_LEATHER, qty: 1 },
						{ item: GameData.Item.KUMBHIRA_LEATHER, qty: 1 },
						{ item: GameData.Item.IRIDESCENT_SILK, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_LINEN_PARASOL]: {
		name: GameData.Item.CONNOISSEURS_LINEN_PARASOL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_LINEN_PARASOL,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_WATERPROOF_CLOTH, qty: 1 },
						{ item: GameData.Item.MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.LINEN_CANVAS, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_TOPIARY_MOOGLE]: {
		name: GameData.Item.CONNOISSEURS_TOPIARY_MOOGLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_TOPIARY_MOOGLE,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_RAKTIKA_SEEDLING, qty: 1 },
						{ item: GameData.Item.GRADE_5_INTELLIGENCE_ALKAHEST, qty: 3 },
						{ item: GameData.Item.GROWTH_FORMULA_KAPPA, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 4 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_SQUID_BAGUETTE]: {
		name: GameData.Item.CONNOISSEURS_SQUID_BAGUETTE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEURS_SQUID_BAGUETTE,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_SQUID_INK, qty: 1 },
						{ item: GameData.Item.NORTHERN_SEA_SALT, qty: 3 },
						{ item: GameData.Item.UPLAND_WHEAT_FLOUR, qty: 3 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_SOILED_FEMUR]: {
		name: GameData.Item.CONNOISSEURS_SOILED_FEMUR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.WEATHERING, x: 17, y: 15 }, method: GameData.GatherMethod.MINING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 70, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.CONNOISSEURS_MIRACLE_APPLE]: {
		name: GameData.Item.CONNOISSEURS_MIRACLE_APPLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.MITHAI_GLORIANDA, x: 26, y: 19 }, method: GameData.GatherMethod.LOGGING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 70, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.GOLD_DUSTFISH]: {
		name: GameData.Item.GOLD_DUSTFISH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.GOLD_DUSTFISH, hole: GameData.Fishing.NABAATH_SEVERANCE, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 40, maxQtyPerJob: 80,
			},
		],
	},
	[GameData.Item.FORGIVEN_MELANCHOLY]: {
		name: GameData.Item.FORGIVEN_MELANCHOLY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.FORGIVEN_MELANCHOLY, hole: GameData.Fishing.ISLE_OF_KEN, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 40, maxQtyPerJob: 80,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_BOOKSHELF]: {
		name: GameData.Item.CONNOISSEUR_BOOKSHELF,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_BOOKSHELF,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_DARK_CHESTNUT_LUMBER, qty: 1 },
						{ item: GameData.Item.INTEGRAL_LUMBER, qty: 1 },
						{ item: GameData.Item.IRONWOOD_LUMBER, qty: 1 },
						{ item: GameData.Item.MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_CHANDELIER]: {
		name: GameData.Item.CONNOISSEUR_CHANDELIER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_CHANDELIER,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BISMUTH_INGOT, qty: 1 },
						{ item: GameData.Item.CHONDRITE_INGOT, qty: 1 },
						{ item: GameData.Item.MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.PHRYGIAN_GOLD_INGOT, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_ESCUTCHEON]: {
		name: GameData.Item.CONNOISSEUR_ESCUTCHEON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_ESCUTCHEON,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_COBALT_PLATE, qty: 1 },
						{ item: GameData.Item.CHONDRITE_INGOT, qty: 1 },
						{ item: GameData.Item.MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.IRONWOOD_LUMBER, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_BAGHNAKHS]: {
		name: GameData.Item.CONNOISSEUR_BAGHNAKHS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_BAGHNAKHS,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BLUESPIRIT_TILE, qty: 1 },
						{ item: GameData.Item.STAR_QUARTZ, qty: 1 },
						{ item: GameData.Item.PHRYGIAN_GOLD_INGOT, qty: 1 },
						{ item: GameData.Item.MANGANESE_INGOT, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_DRINKING_APKALLU]: {
		name: GameData.Item.CONNOISSEUR_DRINKING_APKALLU,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_DRINKING_APKALLU,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_GREEN_GLIDER_LEATHER, qty: 1 },
						{ item: GameData.Item.OPHIOTAUROS_LEATHER, qty: 1 },
						{ item: GameData.Item.PHRYGIAN_GOLD_INGOT, qty: 1 },
						{ item: GameData.Item.APKALLU_DOWN, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_JACKET]: {
		name: GameData.Item.CONNOISSEUR_JACKET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_JACKET,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_WATERPROOF_CLOTH, qty: 1 },
						{ item: GameData.Item.AR_CAEAN_VELVET, qty: 1 },
						{ item: GameData.Item.SCARLET_MOKO_CLOTH, qty: 1 },
						{ item: GameData.Item.SAIGA_LEATHER, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_PLANTER_PARTITION]: {
		name: GameData.Item.CONNOISSEUR_PLANTER_PARTITION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_PLANTER_PARTITION,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_RAKTIKA_SEEDLING, qty: 1 },
						{ item: GameData.Item.IRONWOOD_LUMBER, qty: 1 },
						{ item: GameData.Item.GRADE_5_VITALITY_ALKAHEST, qty: 1 },
						{ item: GameData.Item.GROWTH_FORMULA_KAPPA, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 4 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_SPAGHETTI_AL_NERO]: {
		name: GameData.Item.CONNOISSEUR_SPAGHETTI_AL_NERO,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_SPAGHETTI_AL_NERO,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_SQUID_INK, qty: 1 },
						{ item: GameData.Item.PERILLA_OIL, qty: 3 },
						{ item: GameData.Item.GARLEAN_CHEESE, qty: 3 },
						{ item: GameData.Item.VERMICELLI, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 30, maxQtyPerJob: 90,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_AURUM_REGIS_ORE]: {
		name: GameData.Item.CONNOISSEUR_AURUM_REGIS_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.BRIGHT_CLIFF, x: 33, y: 29 }, method: GameData.GatherMethod.MINING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 70, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_CLOVES]: {
		name: GameData.Item.CONNOISSEUR_CLOVES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.CENTRAL_HILLS_OF_AMBER, x: 18, y: 19 }, method: GameData.GatherMethod.LOGGING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 70, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.OIL_SLICK]: {
		name: GameData.Item.OIL_SLICK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.OIL_SLICK, hole: GameData.Fishing.WHITE_OIL_FALLS, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 40, maxQtyPerJob: 80,
			},
		],
	},
	[GameData.Item.GONZALOS_GRACE]: {
		name: GameData.Item.GONZALOS_GRACE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.GONZALOS_GRACE, hole: GameData.Fishing.WEST_CALIBAN_GAP, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 40, maxQtyPerJob: 80,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_BAMBOO_FENCE]: {
		name: GameData.Item.CONNOISSEUR_BAMBOO_FENCE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_BAMBOO_FENCE,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BAMBOO_STICK, qty: 1 },
						{ item: GameData.Item.INTEGRAL_LOG, qty: 1 },
						{ item: GameData.Item.LIMESTONE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_ROUSING_CHRONOMETER]: {
		name: GameData.Item.CONNOISSEUR_ROUSING_CHRONOMETER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_ROUSING_CHRONOMETER,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_DURALUMINUM_INGOT, qty: 1 },
						{ item: GameData.Item.CHONDRITE, qty: 1 },
						{ item: GameData.Item.RAW_STAR_QUARTZ, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_TRUMPET]: {
		name: GameData.Item.CONNOISSEUR_TRUMPET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_TRUMPET,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BRASHGOLD_PLATE, qty: 1 },
						{ item: GameData.Item.TRUEGOLD_ORE, qty: 1 },
						{ item: GameData.Item.HORSE_CHESTNUT_LOG, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_WASHBASIN]: {
		name: GameData.Item.CONNOISSEUR_WASHBASIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_WASHBASIN,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_MARBLE, qty: 1 },
						{ item: GameData.Item.PEWTER_ORE, qty: 1 },
						{ item: GameData.Item.BISMUTH_ORE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_TARGE]: {
		name: GameData.Item.CONNOISSEUR_TARGE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_TARGE,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_CHALICOTHERIUM_LEATHER, qty: 1 },
						{ item: GameData.Item.HORSE_CHESTNUT_LOG, qty: 1 },
						{ item: GameData.Item.MANGANESE_ORE, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_PETASOS]: {
		name: GameData.Item.CONNOISSEUR_PETASOS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_PETASOS,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_DUSKCOURT_CLOTH, qty: 1 },
						{ item: GameData.Item.RUBY_COTTON_BOLL, qty: 1 },
						{ item: GameData.Item.AR_CAEAN_COTTON_BOLL, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_LUNAR_CURTAIN]: {
		name: GameData.Item.CONNOISSEUR_LUNAR_CURTAIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_LUNAR_CURTAIN,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_CUDWEED, qty: 1 },
						{ item: GameData.Item.LUNATENDER_BLOSSOM, qty: 1 },
						{ item: GameData.Item.MOUSSE_FLESH, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 4 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_CRAB_CAKES]: {
		name: GameData.Item.CONNOISSEUR_CRAB_CAKES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOISSEUR_CRAB_CAKES,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BLUE_CRAB, qty: 1 },
						{ item: GameData.Item.UPLAND_WHEAT, qty: 1 },
						{ item: GameData.Item.EGG_OF_ELPIS, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_ASPHALTUM]: {
		name: GameData.Item.CONNOISSEUR_ASPHALTUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.GOOD_JENANNAS_GRACE, x: 12, y: 11 }, method: GameData.GatherMethod.MINING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 110, maxQtyPerJob: 220,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_GIANTHIVE_CHIP]: {
		name: GameData.Item.CONNOISSEUR_GIANTHIVE_CHIP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.CITIA_SWAMPS, x: 15, y: 35 }, method: GameData.GatherMethod.LOGGING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 110, maxQtyPerJob: 220,
			},
		],
	},
	[GameData.Item.DEADWOOD_SHADOW]: {
		name: GameData.Item.DEADWOOD_SHADOW,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			fishingHoles: [
				{
					fish: GameData.Fish.DEADWOOD_SHADOW,
					hole: GameData.Fishing.MJRLS_TEARS,
					bait: [GameData.Bait.SELECT_BAIT_BALL], mooch: [[{ fish: GameData.Fish.GOLDING, bait: [GameData.Bait.SELECT_BAIT_BALL] }]],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 85, maxQtyPerJob: 170,
			},
		],
	},
	[GameData.Item.RONKAN_BULLION]: {
		name: GameData.Item.RONKAN_BULLION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			fishingHoles: [
				{ fish: GameData.Fish.RONKAN_BULLION, hole: GameData.Fishing.MJRLS_TEARS, bait: [GameData.Bait.SELECT_BAIT_BALL], mooch: [[{ fish: GameData.Fish.GOLDING, bait: [GameData.Bait.SELECT_BAIT_BALL] }]] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 43, maxQtyPerJob: 57,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_SHISHI_ODOSHI]: {
		name: GameData.Item.CONNOSISSEUR_SHISHI_ODOSHI,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_SHISHI_ODOSHI,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BAMBOO_STICK, qty: 1 },
						{ item: GameData.Item.AMBROSIAL_WATER, qty: 1 },
						{ item: GameData.Item.SILTSTONE, qty: 1 },
						{ item: GameData.Item.GRANITE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_RETAINER_BELL]: {
		name: GameData.Item.CONNOSISSEUR_RETAINER_BELL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_RETAINER_BELL,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_DURALUMINUM_INGOT, qty: 1 },
						{ item: GameData.Item.INTEGRAL_LOG, qty: 1 },
						{ item: GameData.Item.PEWTER_ORE, qty: 1 },
						{ item: GameData.Item.WILDFOWN_FEATHER, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_MARCHING_HORN]: {
		name: GameData.Item.CONNOSISSEUR_MARCHING_HORN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_MARCHING_HORN,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BRASHGOLD_PLATE, qty: 1 },
						{ item: GameData.Item.MAHOGANY_LOG, qty: 1 },
						{ item: GameData.Item.BISMUTH_ORE, qty: 1 },
						{ item: GameData.Item.MANGANESE_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 4 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_MARBLE_FOUNTAIN]: {
		name: GameData.Item.CONNOSISSEUR_MARBLE_FOUNTAIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_MARBLE_FOUNTAIN,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_MARBLE, qty: 1 },
						{ item: GameData.Item.AMBROSIAL_WATER, qty: 1 },
						{ item: GameData.Item.ANNITE, qty: 1 },
						{ item: GameData.Item.GRANITE, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 4 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_LEATHER_JACKET]: {
		name: GameData.Item.CONNOSISSEUR_LEATHER_JACKET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_LEATHER_JACKET,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_CHALICOTHERIUM_LEATHER, qty: 1 },
						{ item: GameData.Item.RUBY_COTTON_BOLL, qty: 1 },
						{ item: GameData.Item.ALMASTY_FUR, qty: 1 },
						{ item: GameData.Item.AR_CAEAN_COTTON_BOLL, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_FAT_CAT_SOFA]: {
		name: GameData.Item.CONNOSISSEUR_FAT_CAT_SOFA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_FAT_CAT_SOFA,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_DUSKCOURT_CLOTH, qty: 1 },
						{ item: GameData.Item.ALMASTY_FUR, qty: 1 },
						{ item: GameData.Item.AR_CAEAN_COTTON_BOLL, qty: 1 },
						{ item: GameData.Item.SCARLET_MOKO_GRASS, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 4 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_TINCTURE_OF_VITALITY]: {
		name: GameData.Item.CONNOSISSEUR_TINCTURE_OF_VITALITY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_TINCTURE_OF_VITALITY,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_CUDWEED, qty: 1 },
						{ item: GameData.Item.PETALOUDA_SCALES, qty: 1 },
						{ item: GameData.Item.BERKANAN_SAP, qty: 1 },
						{ item: GameData.Item.AMRA, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 4 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOSISSEUR_CHILI_CRAB]: {
		name: GameData.Item.CONNOSISSEUR_CHILI_CRAB,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CONNOSISSEUR_CHILI_CRAB,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 90,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SELECT_BLUE_CRAB, qty: 1 },
						{ item: GameData.Item.THAVNAIRIAN_PERILLA_LEAF, qty: 1 },
						{ item: GameData.Item.BLOOD_TOMATO, qty: 1 },
						{ item: GameData.Item.PEARL_GINGER, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 4 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_RAW_ONYX]: {
		name: GameData.Item.CONNOISSEUR_RAW_ONYX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.NORVRANDT_SLOPE, x: 34, y: 22 }, method: GameData.GatherMethod.MINING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 110, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.CONNOISSEUR_GLIMSHROOM]: {
		name: GameData.Item.CONNOISSEUR_GLIMSHROOM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.NORVRANDT_SLOPE, x: 37, y: 13 }, method: GameData.GatherMethod.LOGGING, collectable: true }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 110, maxQtyPerJob: 210,
			},
		],
	},
	[GameData.Item.LITTLE_BOUNTY]: {
		name: GameData.Item.LITTLE_BOUNTY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.LITTLE_BOUNTY, hole: GameData.Fishing.SAINT_FATHRICS_TEMPLE, bait: [GameData.Bait.SELECT_BAIT_BALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 85, maxQtyPerJob: 170,
			},
		],
	},
	[GameData.Item.SAINT_FATHRICS_FACE]: {
		name: GameData.Item.SAINT_FATHRICS_FACE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			fishingHoles: [
				{ fish: GameData.Fish.SAINT_FATHRICS_FACE, hole: GameData.Fishing.SAINT_FATHRICS_TEMPLE, bait: [GameData.Bait.SELECT_BAIT_BALL] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 43, maxQtyPerJob: 57,
			},
		],
	},
	[GameData.Item.SELECT_DARK_CHESTNUT_LUMBER]: {
		name: GameData.Item.SELECT_DARK_CHESTNUT_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.RED_PINE_LUMBER]: {
		name: GameData.Item.RED_PINE_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RED_PINE_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 84,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RED_PINE_LOG, qty: 5 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.RED_PINE_LOG]: {
		name: GameData.Item.RED_PINE_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.EBLAN_RIME, x: 16, y: 29 }, method: GameData.GatherMethod.LOGGING }] },
		used: [],
	},
	[GameData.Item.LINEN_CANVAS]: {
		name: GameData.Item.LINEN_CANVAS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.LINEN_CANVAS,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 36,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.LINEN_YARN, qty: 2 },
						{ item: GameData.Item.COTTON_YARN, qty: 1 },
						{ item: GameData.Item.BEESWAX, qty: 1 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 4 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.COTTON_YARN]: {
		name: GameData.Item.COTTON_YARN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.COTTON_YARN,
					qtyMade: 2,
					crafter: Job.WVR,
					level: 12,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.COTTON_BOLL, qty: 2 },
						{ item: GameData.Item.LIGHTNING_SHARD, qty: 1 },
					],
				},
			],
			shops: [
				{ shop: GameData.Shop.ESMENET, cost: [{ price: 22, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 22, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 22, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SYLPHIC_VENDOR, cost: [{ price: 22, currency: GameData.Currency.GIL }, { price: 1, currency: GameData.Currency.SYLPHIC_GOLDLEAF }] },
			],
		},
		used: [],
	},
	[GameData.Item.BEESWAX]: {
		name: GameData.Item.BEESWAX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.BEESWAX,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 10,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.BEEHIVE_CHIP, qty: 3 },
						{ item: GameData.Item.WATER_SHARD, qty: 1 },
					],
				},
			],
			shops: [
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 14, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 14, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 14, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.COTTON_BOLL]: {
		name: GameData.Item.COTTON_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.BENTBRANCH, x: 22, y: 24 }, method: GameData.GatherMethod.HARVESTING }],
			shops: [
				{ shop: GameData.Shop.GIGIMA, cost: [{ price: 10, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 10, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 10, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.BEEHIVE_CHIP]: {
		name: GameData.Item.BEEHIVE_CHIP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.NORTH_SHROUD, x: 26, y: 27 }, method: GameData.GatherMethod.LOGGING }],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ESMENET, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.JOSSY, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SHIRAKASHI, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.VRAL, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.TRAVELING_MATERIAL_SUPPLIER, cost: [{ price: 5, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_BISMUTH_INGOT]: {
		name: GameData.Item.SELECT_BISMUTH_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.PEWTER_INGOT]: {
		name: GameData.Item.PEWTER_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PEWTER_INGOT,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 82,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.PEWTER_ORE, qty: 6 },
						{ item: GameData.Item.TIN_ORE, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.OROSHIGANE_INGOT]: {
		name: GameData.Item.OROSHIGANE_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.OROSHIGANE_INGOT,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 64,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DOMAN_IRON_ORE, qty: 4 },
						{ item: GameData.Item.IRON_ORE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 4 },
					],
				},
				{
					itemMade: GameData.Item.OROSHIGANE_INGOT,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 64,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DOMAN_IRON_ORE, qty: 4 },
						{ item: GameData.Item.IRON_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 4 },
					],
				},
			],
			shops: [
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 3264, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.PEWTER_ORE]: {
		name: GameData.Item.PEWTER_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.THAVNAIR, x: 10, y: 14 }, method: GameData.GatherMethod.QUARRYING },
			],
		},
		used: [],
	},
	[GameData.Item.TIN_ORE]: {
		name: GameData.Item.TIN_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.WESTERN_THANALAN, x: 22, y: 29 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.CENTRAL_THANALAN, x: 20, y: 23 }, method: GameData.GatherMethod.MINING },
			],
			shops: [
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ENGERRAND, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.FRIDURIH, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ORHOYOD, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SMYDHAEMR, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SOEMRWYB, cost: [{ price: 2, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.DOMAN_IRON_ORE]: {
		name: GameData.Item.DOMAN_IRON_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.YANXIA, x: 34, y: 20}, method: GameData.GatherMethod.MINING },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_COBALT_PLATE]: {
		name: GameData.Item.SELECT_COBALT_PLATE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.MANGANESE_INGOT]: {
		name: GameData.Item.MANGANESE_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.MANGANESE_INGOT,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 86,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.MANGANESE_ORE, qty: 5 },
						{ item: GameData.Item.MOLYBDENUM_ORE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
				{
					itemMade: GameData.Item.MANGANESE_INGOT,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 86,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.MANGANESE_ORE, qty: 5 },
						{ item: GameData.Item.MOLYBDENUM_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.CRYSTAL_GLASS]: {
		name: GameData.Item.CRYSTAL_GLASS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.CRYSTAL_GLASS,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 50,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SILEX, qty: 3 },
						{ item: GameData.Item.NATRON, qty: 1 },
						{ item: GameData.Item.MINIUM, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 5 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.MANGANESE_ORE]: {
		name: GameData.Item.MANGANESE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.ELPIS, x: 24, y: 7 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [],
	},
	[GameData.Item.MOLYBDENUM_ORE]: {
		name: GameData.Item.MOLYBDENUM_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.LOCHS, x: 11, y: 16 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [],
	},
	[GameData.Item.SILEX]: {
		name: GameData.Item.SILEX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.SOUTHERN_THANALAN, x: 21, y: 29 }, method: GameData.GatherMethod.QUARRYING },
			],
		},
		used: [],
	},
	[GameData.Item.NATRON]: {
		name: GameData.Item.NATRON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.NATRON,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 25,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.EFFERVESCENT_WATER, qty: 1 },
						{ item: GameData.Item.ROCK_SALT, qty: 1 },
						{ item: GameData.Item.WATER_SHARD, qty: 2 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.MINIUM]: {
		name: GameData.Item.MINIUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 200, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 200, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 200, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.IXALI_VENDOR, cost: [{ price: 1, currency: GameData.Currency.IXALI_OAKNOT }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_BLUESPIRIT_TILE]: {
		name: GameData.Item.SELECT_BLUESPIRIT_TILE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.MANASILVER_NUGGET]: {
		name: GameData.Item.MANASILVER_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.MANASILVER_NUGGET,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 74,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.MANASILVER_SAND, qty: 4 },
						{ item: GameData.Item.SILVER_ORE, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_GREEN_GLIDER_LEATHER]: {
		name: GameData.Item.SELECT_GREEN_GLIDER_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.KUMBHIRA_LEATHER]: {
		name: GameData.Item.KUMBHIRA_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.KUMBHIRA_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 86,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.KUMBHIRA_SKIN, qty: 4 },
						{ item: GameData.Item.EBLAN_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.IRIDESCENT_SILK]: {
		name: GameData.Item.IRIDESCENT_SILK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.IRIDESCENT_SILK,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 72,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.IRIDESCENT_SILK_THREAD, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 6 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.KUMBHIRA_SKIN]: {
		name: GameData.Item.KUMBHIRA_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.KUMBHIRA],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.MAHVEYDAH, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.IRIDESCENT_SILK_THREAD]: {
		name: GameData.Item.IRIDESCENT_SILK_THREAD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.IRIDESCENT_SILK_THREAD,
					qtyMade: 3,
					crafter: Job.WVR,
					level: 72,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.IRIDESCENT_COCOON, qty: 4 },
						{ item: GameData.Item.EFFERVESCENT_WATER, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.IRIDESCENT_COCOON]: {
		name: GameData.Item.IRIDESCENT_COCOON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.GOOD_JENANNAS_GRACE, x: 11, y: 24 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_WATERPROOF_CLOTH]: {
		name: GameData.Item.SELECT_WATERPROOF_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.SELECT_RAKTIKA_SEEDLING]: {
		name: GameData.Item.SELECT_RAKTIKA_SEEDLING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.GRADE_5_INTELLIGENCE_ALKAHEST]: {
		name: GameData.Item.GRADE_5_INTELLIGENCE_ALKAHEST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.GRADE_5_INTELLIGENCE_ALKAHEST,
					qtyMade: 3,
					crafter: Job.ALC,
					level: 83,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.UNDERGROUND_SPRING_WATER, qty: 2 },
						{ item: GameData.Item.LUNATENDER_BLOSSOM, qty: 1 },
						{ item: GameData.Item.FERNLEAF_LAVENDER, qty: 2 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.GROWTH_FORMULA_KAPPA]: {
		name: GameData.Item.GROWTH_FORMULA_KAPPA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.GROWTH_FORMULA_KAPPA,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 76,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HOPTRAP_LEAF, qty: 2 },
						{ item: GameData.Item.VAMPIRE_VINE_SAP, qty: 2 },
						{ item: GameData.Item.UNDERGROUND_SPRING_WATER, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.FERNLEAF_LAVENDER]: {
		name: GameData.Item.FERNLEAF_LAVENDER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.BLIND_FOREST, x: 27, y: 25 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.HOPTRAP_LEAF]: {
		name: GameData.Item.HOPTRAP_LEAF,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.HOPTRAP],
			shops: [
				{ shop: GameData.Shop.GRAMSOL, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.PEDRONILLE, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SIULMET, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_SQUID_INK]: {
		name: GameData.Item.SELECT_SQUID_INK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 60, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.NORTHERN_SEA_SALT]: {
		name: GameData.Item.NORTHERN_SEA_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.NORTHERN_SEA_SALT,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 81,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SHARLAYAN_ROCK_SALT, qty: 6 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.UPLAND_WHEAT_FLOUR]: {
		name: GameData.Item.UPLAND_WHEAT_FLOUR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.UPLAND_WHEAT_FLOUR,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 74,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.UPLAND_WHEAT, qty: 5 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SHARLAYAN_ROCK_SALT]: {
		name: GameData.Item.SHARLAYAN_ROCK_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.LABYRINTHOS, x: 30, y: 9 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [],
	},
	[GameData.Item.UPLAND_WHEAT]: {
		name: GameData.Item.UPLAND_WHEAT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.SHADOW_FAULT, x: 16, y: 36 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.IRONWOOD_LUMBER]: {
		name: GameData.Item.IRONWOOD_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.IRONWOOD_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 86,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.IRONWOOD_LOG, qty: 5 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.PHRYGIAN_GOLD_INGOT]: {
		name: GameData.Item.PHRYGIAN_GOLD_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PHRYGIAN_GOLD_INGOT,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 84,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.PHRYGIAN_GOLD_ORE, qty: 5 },
						{ item: GameData.Item.ZINC_ORE, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.ZINC_ORE]: {
		name: GameData.Item.ZINC_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.CENTRAL_THANALAN, x: 19, y: 21 }, method: GameData.GatherMethod.MINING },
			],
			shops: [
				{ shop: GameData.Shop.AISTAN, cost: [{ price: 20, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.MATERIAL_SUPPLIER, cost: [{ price: 20, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.ALLAGAN_RESUPPLY_NODE, cost: [{ price: 20, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.APKALLU_DOWN]: {
		name: GameData.Item.APKALLU_DOWN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.APKALLU],
			markets: { [Market.UNIVERSALIS]: -1 },
		},
		used: [],
	},
	[GameData.Item.SCARLET_MOKO_CLOTH]: {
		name: GameData.Item.SCARLET_MOKO_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SCARLET_MOKO_CLOTH,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 86,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SCARLET_MOKO_GRASS, qty: 5 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SAIGA_LEATHER]: {
		name: GameData.Item.SAIGA_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SAIGA_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 84,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SAIGA_HIDE, qty: 4 },
						{ item: GameData.Item.EBLAN_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SCARLET_MOKO_GRASS]: {
		name: GameData.Item.SCARLET_MOKO_GRASS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.ELPIS, x: 21, y: 24 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.SAIGA_HIDE]: {
		name: GameData.Item.SAIGA_HIDE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.SAIGA],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.ZAWAWA, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.PERILLA_OIL]: {
		name: GameData.Item.PERILLA_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.PERILLA_OIL,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 82,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.THAVNAIRIAN_PERILLA_LEAF, qty: 6 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.GARLEAN_CHEESE]: {
		name: GameData.Item.GARLEAN_CHEESE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.GARLEAN_CHEESE,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 84,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.OVIBOS_MILK, qty: 5 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.VERMICELLI]: {
		name: GameData.Item.VERMICELLI,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.VERMICELLI,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 56,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HIGHLAND_FLOUR, qty: 3 },
						{ item: GameData.Item.DRAVANIAN_MISTLETOE, qty: 1 },
						{ item: GameData.Item.ABALATHIAN_ROCK_SALT, qty: 1 },
						{ item: GameData.Item.FIRE_SHARD, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.THAVNAIRIAN_PERILLA_LEAF]: {
		name: GameData.Item.THAVNAIRIAN_PERILLA_LEAF,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.THAVNAIR, x: 22, y: 10 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.OVIBOS_MILK]: {
		name: GameData.Item.OVIBOS_MILK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.OVIBOS],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.ZAWAWA, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.ABALATHIAN_ROCK_SALT]: {
		name: GameData.Item.ABALATHIAN_ROCK_SALT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.SEA_OF_CLOUDS, x: 8, y: 8 }, method: GameData.GatherMethod.QUARRYING, timedNode: true, times: ["10AM/10PM"] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_BAMBOO_STICK]: {
		name: GameData.Item.SELECT_BAMBOO_STICK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.LIMESTONE]: {
		name: GameData.Item.LIMESTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.WESTERN_LA_NOSCEA, x: 27, y: 25 }, method: GameData.GatherMethod.QUARRYING },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_DURALUMINUM_INGOT]: {
		name: GameData.Item.SELECT_DURALUMINUM_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.SELECT_BRASHGOLD_PLATE]: {
		name: GameData.Item.SELECT_BRASHGOLD_PLATE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.TRUEGOLD_ORE]: {
		name: GameData.Item.TRUEGOLD_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.BOOKMANS_SHELVES, x: 7, y: 19 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [],
	},
	[GameData.Item.HORSE_CHESTNUT_LOG]: {
		name: GameData.Item.HORSE_CHESTNUT_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.LABYRINTHOS, x: 14, y: 7 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_MARBLE]: {
		name: GameData.Item.SELECT_MARBLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.SELECT_CHALICOTHERIUM_LEATHER]: {
		name: GameData.Item.SELECT_CHALICOTHERIUM_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.SELECT_DUSKCOURT_CLOTH]: {
		name: GameData.Item.SELECT_DUSKCOURT_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.RUBY_COTTON_BOLL]: {
		name: GameData.Item.RUBY_COTTON_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.RUBY_SEA, x: 28, y: 22 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_CUDWEED]: {
		name: GameData.Item.SELECT_CUDWEED,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.MOUSSE_FLESH]: {
		name: GameData.Item.MOUSSE_FLESH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.MOUSSE],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.TRADINGWAY, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.SELECT_BLUE_CRAB]: {
		name: GameData.Item.SELECT_BLUE_CRAB,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {shops: [{ shop: GameData.Shop.QUINNANA, cost: [{ price: 70, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] }]},
		used: [],
	},
	[GameData.Item.EGG_OF_ELPIS]: {
		name: GameData.Item.EGG_OF_ELPIS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.BIRD_OF_ELPIS],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.AISARA, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.AMBROSIAL_WATER]: {
		name: GameData.Item.AMBROSIAL_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.ELPIS, x: 14, y: 18 }, method: GameData.GatherMethod.QUARRYING },
			],
		},
		used: [],
	},
	[GameData.Item.GRANITE]: {
		name: GameData.Item.GRANITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.CENTRAL_SHROUD, x: 14, y: 21 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [],
	},
	[GameData.Item.WILDFOWN_FEATHER]: {
		name: GameData.Item.WILDFOWN_FEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.LOWER_PATHS, x: 17, y: 29 }, method: GameData.GatherMethod.HARVESTING },
			],
			shops: [
				{ shop: GameData.Shop.SYLPHIC_VENDOR, cost: [{ price: 259, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.SYLPHIC_VENDOR, cost: [{ price: 1, currency: GameData.Currency.SYLPHIC_GOLDLEAF }] },
			],
		},
		used: [],
	},
	[GameData.Item.BERKANAN_SAP]: {
		name: GameData.Item.BERKANAN_SAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.BERKANAN],
			shops: [
				{ shop: GameData.Shop.FAEZBROES, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.AMRA]: {
		name: GameData.Item.AMRA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.VAJRALANGULA],
			shops: [
				{ shop: GameData.Shop.GADFRID, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.MAHVEYDAH, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.SAJAREEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.BLOOD_TOMATO]: {
		name: GameData.Item.BLOOD_TOMATO,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.GOOD_JENANNAS_GRACE, x: 11, y: 24 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.PEARL_GINGER]: {
		name: GameData.Item.PEARL_GINGER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.EASTERN_THANALAN, x: 15, y: 22 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [],
	},
	[GameData.Item.CUSTOM_ICE_CRYSTAL]: {
		name: GameData.Item.CUSTOM_ICE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.LAKELAND, x: 17, y: 15 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 210,
			},
		],
	},
	[GameData.Item.CUSTOM_WIND_CRYSTAL]: {
		name: GameData.Item.CUSTOM_WIND_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.MITHAI_GLORIANDA, x: 26, y: 19 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_CHORA_ZOIS_CRYSTALLINE, RelicData.Step.CUSTOMISED_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 210,
			},
		],
	},
	[GameData.Item.BRILLIANT_LIGHTNING_CLUSTER]: {
		name: GameData.Item.BRILLIANT_LIGHTNING_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.BRIGHT_CLIFF, x: 33, y: 29 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 210,
			},
		],
	},
	[GameData.Item.BRILLIANT_EARTH_CLUSTER]: {
		name: GameData.Item.BRILLIANT_EARTH_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.CENTRAL_HILLS_OF_AMBER, x: 18, y: 19 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_BRILLIANT, RelicData.Step.BRILLIANT_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 210,
			},
		],
	},
	[GameData.Item.INSPIRATIONAL_WIND_CLUSTER]: {
		name: GameData.Item.INSPIRATIONAL_WIND_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.GOOD_JENANNAS_GRACE, x: 14, y: 10 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 220,
			},
		],
	},
	[GameData.Item.INSPIRATIONAL_FIRE_CLUSTER]: {
		name: GameData.Item.INSPIRATIONAL_FIRE_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.RAKTIKA_GREATWOOD, x: 15, y: 35 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_VRANDTIC_VISIONARYS, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 220,
			},
		],
	},
	[GameData.Item.NIGHTFORGED_ICE_CLUSTER]: {
		name: GameData.Item.NIGHTFORGED_ICE_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.TEMPEST, x: 34, y: 22 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 220,
			},
		],
	},
	[GameData.Item.NIGHTFORGED_WATER_CLUSTER]: {
		name: GameData.Item.NIGHTFORGED_WATER_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.TEMPEST, x: 37, y: 13 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SPLENDOROUS, RelicData.Part.TOOL_LODESTAR, RelicData.Step.NIGHTFORGED_COMPONENT, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 220,
			},
		],
	},
	[GameData.Item.COSMIC_CRYSTALLITE]: {
		name: GameData.Item.COSMIC_CRYSTALLITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.JUBRUNNAH, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_MANDERVILLE, RelicData.Part.WEAPON_MANDERVILLOUS, RelicData.Step.MANDERVILLOUS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_MANDERVILLE],
				qtyPerJob: 3,
			},
		],
	},
} satisfies Partial<{ [key in GameData.Item]: Info.Item }>;
